import { useAuth0 } from '@auth0/auth0-react';
import useProducts from '../../../../../../../../actions/products';
import { GTM_EVENTS } from '../../../../../../../../constants/gtmEvents';
import { pushToDataLayer } from '../../../../../../../../utils/gtm';
import handleProductLanguage from '../../../../../../../../utils/handleProductLanguage';

export default function ControlCartButton({
  id,
  isLoading = false,
  addItem,
  currentColorProduct,
}) {
  const { isAuthenticated } = useAuth0();
  const { isChecked, setSelectedProducts } = useProducts(id);

  const handleAddToCart = event => {
    if (!isChecked(id) && event.target.checked && isAuthenticated) {
      pushToDataLayer({ ecommerce: null });

      pushToDataLayer({
        event: GTM_EVENTS.ADD_TO_CART,
        distributor: 'Feller',
        add_to_cart_location: 'product_listing',
        ecommerce: {
          currency: 'CHF',
          value: 0.0,
          items: [
            {
              item_id: currentColorProduct?.id || '',
              item_name: handleProductLanguage(currentColorProduct?.name) || '',
              item_brand: currentColorProduct?.category || '',
              item_list_name: currentColorProduct?.category || '',
              item_list_id: currentColorProduct?.category || '',
              item_category: currentColorProduct?.category || '',
              item_variant: currentColorProduct?.design?.color || '',
              price: 0.0,
              quantity: 1,
            },
          ],
        },
      });
    }

    setSelectedProducts(event);
  };

  return (
    <>
      <label
        role="button"
        className={`card-link btn btn-primary btn-sm d-inline-flex justify-content-center align-items-start gap-1 ${
          isChecked(id) ? 'active' : ''
        }`}
      >
        <input
          name="select-button"
          className="form-check-input position-absolute btn opacity-0"
          value={id}
          onChange={handleAddToCart}
          checked={isChecked(id)}
          type="checkbox"
          disabled={isLoading}
        />
        <small>{addItem}</small>
      </label>
    </>
  );
}
